/**
 * Player HTML5 đơn giản cho khối intro — không dùng iframe.
 * preload="metadata" + điều khiển tùy chỉnh (theo hướng tối ưu web.dev / MDN).
 */
APP.introBannerVideo = function () {
	const root = document.querySelector('[data-intro-video]')
	if (!root) return

	const video = root.querySelector('.intro-video-player__media')
	const btnToggle = root.querySelector('.intro-video-player__toggle')
	const btnBigPlay = root.querySelector('.intro-video-player__big-play')
	const btnMute = root.querySelector('.intro-video-player__mute')
	const btnFs = root.querySelector('.intro-video-player__fullscreen')
	const track = root.querySelector('.intro-video-player__track')
	const fill = root.querySelector('.intro-video-player__fill')
	const curEl = root.querySelector('.intro-video-player__current')
	const durEl = root.querySelector('.intro-video-player__duration')

	if (
		!video ||
		!btnToggle ||
		!btnBigPlay ||
		!btnMute ||
		!btnFs ||
		!track ||
		!fill ||
		!curEl ||
		!durEl
	) {
		return
	}

	const CLASS_PLAYING = 'is-playing'
	const CLASS_STARTED = 'has-started'
	const isVn = typeof lang !== 'undefined' && lang === 'vn'
	const t = isVn
		? {
				play: 'Phát',
				pause: 'Tạm dừng',
				playVideo: 'Phát video',
				mute: 'Tắt tiếng',
				unmute: 'Bật tiếng',
				fullscreen: 'Toàn màn hình',
				exitFullscreen: 'Thoát toàn màn hình',
			}
		: {
				play: 'Play',
				pause: 'Pause',
				playVideo: 'Play video',
				mute: 'Mute',
				unmute: 'Unmute',
				fullscreen: 'Fullscreen',
				exitFullscreen: 'Exit fullscreen',
			}

	function formatTime(seconds) {
		if (!Number.isFinite(seconds) || seconds < 0) return '0:00'
		const m = Math.floor(seconds / 60)
		const s = Math.floor(seconds % 60)
		return m + ':' + (s < 10 ? '0' : '') + s
	}

	function updateDuration() {
		durEl.textContent = formatTime(video.duration)
	}

	function updateProgress() {
		const d = video.duration
		const pct = d && Number.isFinite(d) ? (video.currentTime / d) * 100 : 0
		fill.style.width = pct + '%'
		curEl.textContent = formatTime(video.currentTime)
		track.setAttribute('aria-valuenow', String(Math.round(pct)))
	}

	function setPlayingUi(playing) {
		root.classList.toggle(CLASS_PLAYING, playing)
		btnToggle.setAttribute('aria-label', playing ? t.pause : t.play)
		btnBigPlay.setAttribute('aria-label', playing ? t.pause : t.playVideo)
	}

	function togglePlay() {
		if (video.paused) {
			video.play().catch(function () {})
		} else {
			video.pause()
		}
	}

	function seekFromClientX(clientX) {
		const r = track.getBoundingClientRect()
		const ratio = Math.min(Math.max((clientX - r.left) / r.width, 0), 1)
		if (video.duration && Number.isFinite(video.duration)) {
			video.currentTime = ratio * video.duration
		}
	}

	btnToggle.addEventListener('click', function () {
		togglePlay()
	})
	btnBigPlay.addEventListener('click', function () {
		togglePlay()
	})

	btnMute.addEventListener('click', function () {
		video.muted = !video.muted
		btnMute.setAttribute('aria-label', video.muted ? t.unmute : t.mute)
		btnMute.classList.toggle('is-muted', video.muted)
	})

	function toggleFullscreen() {
		const fsEl = document.fullscreenElement || document.webkitFullscreenElement
		if (fsEl === root) {
			const exitFs =
				document.exitFullscreen ||
				document.webkitExitFullscreen ||
				document.mozCancelFullScreen ||
				document.msExitFullscreen
			if (!exitFs) return
			const ret = exitFs.call(document)
			if (ret && typeof ret.catch === 'function') ret.catch(function () {})
			return
		}
		const req =
			root.requestFullscreen ||
			root.webkitRequestFullscreen ||
			root.mozRequestFullScreen ||
			root.msRequestFullscreen
		if (!req) return
		const ret = req.call(root)
		if (ret && typeof ret.catch === 'function') ret.catch(function () {})
	}

	btnFs.addEventListener('click', function () {
		toggleFullscreen()
	})

	video.addEventListener('play', function () {
		setPlayingUi(true)
		root.classList.add(CLASS_STARTED)
	})
	video.addEventListener('pause', function () {
		setPlayingUi(false)
	})
	video.addEventListener('ended', function () {
		setPlayingUi(false)
	})
	video.addEventListener('timeupdate', updateProgress)
	video.addEventListener('loadedmetadata', function () {
		updateDuration()
		updateProgress()
	})

	let dragging = false
	track.addEventListener('pointerdown', function (e) {
		dragging = true
		track.setPointerCapture(e.pointerId)
		seekFromClientX(e.clientX)
	})
	track.addEventListener('pointermove', function (e) {
		if (!dragging) return
		seekFromClientX(e.clientX)
	})
	function endDrag(e) {
		if (!dragging) return
		dragging = false
		try {
			track.releasePointerCapture(e.pointerId)
		} catch (err) {}
	}
	track.addEventListener('pointerup', endDrag)
	track.addEventListener('pointercancel', endDrag)

	video.addEventListener('click', function (e) {
		if (e.target === video) togglePlay()
	})

	function syncFullscreenClass() {
		const fs = document.fullscreenElement || document.webkitFullscreenElement
		const isFs = fs === root
		root.classList.toggle('is-fullscreen', isFs)
		btnFs.classList.toggle('is-fullscreen-active', isFs)
		btnFs.setAttribute('aria-label', isFs ? t.exitFullscreen : t.fullscreen)
		const fsHidden = btnFs.querySelector('.visually-hidden')
		if (fsHidden) fsHidden.textContent = isFs ? t.exitFullscreen : t.fullscreen
	}
	document.addEventListener('fullscreenchange', syncFullscreenClass)
	document.addEventListener('webkitfullscreenchange', syncFullscreenClass)
	document.addEventListener('mozfullscreenchange', syncFullscreenClass)
	document.addEventListener('MSFullscreenChange', syncFullscreenClass)

	track.addEventListener('keydown', function (e) {
		const d = video.duration
		if (!d || !Number.isFinite(d)) return
		let handled = false
		if (e.key === 'ArrowLeft') {
			video.currentTime = Math.max(0, video.currentTime - 5)
			handled = true
		} else if (e.key === 'ArrowRight') {
			video.currentTime = Math.min(d, video.currentTime + 5)
			handled = true
		} else if (e.key === 'Home') {
			video.currentTime = 0
			handled = true
		} else if (e.key === 'End') {
			video.currentTime = d
			handled = true
		}
		if (handled) e.preventDefault()
	})
}
